import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { FileService } from 'src/app/shared/file.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { FileModel } from 'src/app/shared/file.model';

@Component({
  selector: 'app-files-list',
  templateUrl: './files-list.component.html',
  styleUrls: ['./files-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FilesListComponent {
  @Input() files: FileModel[] | FileList;
  @Input() view = false;

  @Output() changedFiles = new EventEmitter<FileModel[] | FileList>();

  constructor(
    private fileService: FileService,
    protected utils: UtilsService
  ) {}

  delete(id: number) {
    this.utils.showModal(
      'Delete Files',
      'Are you sure you want to delete this file?',
      () => {
        this.fileService.remove(id).subscribe(() => {
          this.utils.showToast('The file was deleted.');
          this.files = Array.from(this.files).filter((file) => file.id !== id);
          this.changedFiles.emit(this.files);
        });
      }
    );
  }

  isImage(name: string) {
    return name && name.match(/.(jpg|jpeg|png|gif|bmp)/i);
  }

  /**
   * Opens the specified URL using the utility function.
   *
   * @param {string} url - The URL to be opened.
   * @return {void} This method does not return a value.
   */
  onOpenUrl(url: string): void {
    this.utils.openUrl(url);
  }

  /**
   * Notifies the user that the URL has been copied to their clipboard via a toast message.
   *
   * @return {void} Does not return any value.
   */
  onCopiedURL(): void {
    this.utils.showToast('The URL is copied to your clipboard.');
  }
}
